import { DOCUMENT, Directive, inject } from '@angular/core';

import { OfferButtonComponentBase } from './offer-button-component-base';

/**
 * @stable
 */
@Directive({
    standalone: true,
})
export class OfferButtonDirective extends OfferButtonComponentBase {
    private readonly _doc = inject(DOCUMENT);

    constructor() {
        super();
        this.doc = this._doc;
    }
}
